import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';



const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight:'29.6vh',
    marginTop:'20px'
  }
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  let rowsData    = []
  let columnsDataForAreaWise = []
  let rowsDataForAreaWise    = []
  

  // const columns = [
  //   { id: 'ULB', label: 'ULB', minWidth: 170 , align: 'center' },
  //   { id: 'Area', label: 'Area', minWidth: 100 , align: 'center'},
  //   {
  //     id: 'Count',
  //     label: 'Count',
  //     minWidth: 170,
  //     align: 'center',
  //     format: (value) => value.toLocaleString('en-US'),
  //   }
  // ];
  
  function createData(ULB, Area) {
    return {ULB, Area };
  }

  function createDataForTFWise(ULB,
  Area,
  Count) {
    return {ULB, Area,Count };
  }
  
  
  /*const rows = [
    createData('Trichy Corp','Sangliyandapuram',50),
    createData('Trichy Corp','E Pudur', 43),
    createData('Trichy Corp','KK Nagar', 60),
    createData('Trichy Corp','Crawford' , 43),
    createData('Trichy Corp','Airport', 39),
    createData('Trichy Corp','Kajamalai', 73),
    createData('Trichy Outer','Nagamangalam', 87),
    createData('Trichy Outer','Gundur', 76)
    
  ];*/

  props.rows.forEach(function(obj){
    let row = createData(obj.tfName,obj.LoadsCount)
    rowsData.push(row)
  })
  props.columnsDataHeaders.forEach(function(obj){
    let column =  { id: obj, label: obj, minWidth: 170 , align: 'center' }
    columnsDataForAreaWise.push(column)
  })

  props.TableDataBody.forEach(function(obj){
    let row = createDataForTFWise(obj.ULBName,obj.AreaName,obj.Count)
    rowsDataForAreaWise.push(row)
  })

  
  const rows    = rowsData
  const columnsForAreaWise = columnsDataForAreaWise
  const rowsForAreaWise    = rowsDataForAreaWise


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <div className="dashboard_new_listing">
  
  <Paper className={classes.root}>
      <TableContainer className={classes.container}>
      <div style={{color:"rgb(102 102 102)", fontSize:"12px", fontWeight:"bolder",paddingTop:"10px",paddingBottom:"10px"}}>Ward / Zone Wise Loads</div>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columnsForAreaWise.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontWeight:'bolder', fontSize:"12px" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              rowsForAreaWise.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                  {columnsForAreaWise.map((column,index) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={index} align={column.align} style={{fontSize:"12px"}}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
        rowsPerPageOptions={[2, 5, 10, 100]}
        component="div"
        count={rowsForAreaWise.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      </TableContainer>

    </Paper>

          
    </div>
  );
}
